var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NcIconSvgWrapper',{staticClass:"favorite-marker-icon",attrs:{"name":_vm.t('photos', 'Favorite'),"svg":_vm.StarSvg}})
}
var staticRenderFns = []

export { render, staticRenderFns }